//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon2 = 0.01;\n\
";
